(function($) {
	var steps = 20;
	var currentFontsize = 100;

	function resize()
	{
		$('html').css('font-size', currentFontsize + '%');
	}
	
	function smaller()
	{
		currentFontsize -= steps;
		resize();
	}

	function bigger()
	{
		currentFontsize += steps;
		resize();
	}

	function normal()
	{
		currentFontsize = 100;
		resize();
	}

	$('.font-resizer-button--smaller').click(smaller);
	$('.font-resizer-button--normal').click(normal);
	$('.font-resizer-button--bigger').click(bigger);
})(jQuery);